module.exports = __webpack_public_path__ + "img/logo-ip.ec3c6188.svg";